export const GET_DATA_REQ = "GET_DATA_REQ"
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS"
export const GET_DATA_ERROR = "GET_DATA_ERROR"

export const ADD_DATA_REQ = "ADD_DATA_REQ"
export const ADD_DATA_SUCCESS = "ADD_DATA_SUCCESS"
export const ADD_DATA_ERROR = "ADD_DATA_ERROR"

export const UPDATE_DATA_REQ = "UPDATE_DATA_REQ"
export const UPDATE_DATA_SUCCESS = "UPDATE_DATA_SUCCESS"
export const UPDATE_DATA_ERROR = "UPDATE_DATA_ERROR"

export const DELETE_DATA_REQ = "DELETE_DATA_REQ"
export const DELETE_DATA_SUCCESS = "DELETE_DATA_SUCCESS"
export const DELETE_DATA_ERROR = "DELETE_DATA_ERROR"